import {
  getBuyerInfoData,
  requestDigest,
  setBuyerSettings,
  setMarketInterest,
  removeMarketInterest
} from 'src/api/mikasa/requests'
import {
  FETCH_BUYER_INFO_REQUEST,
  FETCH_BUYER_INFO_SUCCESS,
  FETCH_BUYER_INFO_FAILURE,
  UPDATE_BUYER_INFO_REQUEST,
  UPDATE_BUYER_INFO_SUCCESS,
  UPDATE_BUYER_INFO_FAILURE,
  UPDATE_MARKET_INTEREST_REQUEST,
  UPDATE_MARKET_INTEREST_SUCCESS,
  UPDATE_MARKET_INTEREST_FAILURE,
  REQUEST_DIGEST_REQUEST,
  REQUEST_DIGEST_SUCCESS,
  REQUEST_DIGEST_FAILURE
} from './actionTypes'
import { flashNotification } from 'src/actions/notification'
import { unmarkBuyerForUnsubscribe } from 'src/actions/buyer/unsubscribe'
import { SUBSCRIPTIONS } from 'src/constants/messages'
import { fetchMarketRecordsDetail } from './marketRecords'
import { selectClientId, selectClientIsBuyer } from 'src/store/selectors/client'
import { selectBuyerSubscribed } from 'src/store/selectors/buyerInfo'
import { selectBuyerUnsubscribeRequested } from 'src/store/selectors/buyer/unsubscribe'

export const fetchBuyerInfoData = buyerId => async dispatch => {
  dispatch({
    type: FETCH_BUYER_INFO_REQUEST
  })

  try {
    const response = await getBuyerInfoData(buyerId)
    dispatch(fetchBuyerInfoSuccess(response))
  } catch (error) {
    dispatch(fetchBuyerInfoFailure(error))
  }
}

export const sendDigestRequest = (buyerId, email) => async dispatch => {
  dispatch({
    type: REQUEST_DIGEST_REQUEST
  })

  try {
    await requestDigest(buyerId, email)
    dispatch({
      type: REQUEST_DIGEST_SUCCESS
    })
  } catch (e) {
    dispatch({
      type: REQUEST_DIGEST_FAILURE
    })
  }
}

export const fetchBuyerInfoSuccess = response => dispatch => {
  dispatch({
    type: FETCH_BUYER_INFO_SUCCESS,
    data: response.data.data
  })
}

export const fetchBuyerInfoFailure = error => dispatch => {
  dispatch({
    type: FETCH_BUYER_INFO_FAILURE,
    error
  })
}

export const updateBuyerInfo = data => async (dispatch, getState) => {
  dispatch(updateBuyerInfoRequest(data))

  const {
    buyerInfo: { id: buyerId }
  } = getState()

  try {
    const res = await setBuyerSettings(buyerId, data)
    dispatch(updateBuyerInfoSuccess(res))
  } catch (err) {
    dispatch(updateBuyerInfoFailure(err))
  }
}

const updateBuyerInfoRequest = data => ({
  type: UPDATE_BUYER_INFO_REQUEST,
  ...data
})

const updateBuyerInfoSuccess = response => ({
  type: UPDATE_BUYER_INFO_SUCCESS,
  data: response.data.data
})

const updateBuyerInfoFailure = error => ({
  type: UPDATE_BUYER_INFO_FAILURE,
  error: {
    message: error.message
  }
})

export const createMarketInterest = zipcode => async (dispatch, getState) => {
  const state = getState()
  const { marketRecords } = state
  const clientId = selectClientId(state)
  const clientIsBuyer = selectClientIsBuyer(state)

  if (!clientIsBuyer) return

  dispatch({
    type: UPDATE_MARKET_INTEREST_REQUEST
  })

  try {
    const { data } = await setMarketInterest(clientId, zipcode)
    dispatch({
      type: UPDATE_MARKET_INTEREST_SUCCESS,
      action: 'add',
      data: data.data
    })
  } catch (error) {
    dispatch({
      type: UPDATE_MARKET_INTEREST_FAILURE,
      error,
      zipcode
    })
  }

  if (!marketRecords.detailRequested[zipcode]) {
    dispatch(fetchMarketRecordsDetail([zipcode]))
  }
}

export const deleteMarketInterest = id => async (dispatch, getState) => {
  const { buyerInfo } = getState()

  dispatch({
    type: UPDATE_MARKET_INTEREST_REQUEST
  })

  try {
    await removeMarketInterest(buyerInfo.id, id)
    dispatch({
      type: UPDATE_MARKET_INTEREST_SUCCESS,
      action: 'remove',
      id
    })
  } catch (error) {
    dispatch({
      type: UPDATE_MARKET_INTEREST_FAILURE,
      error
    })
  }
}

export const setSubscriptionStatus = (status, intl) => async dispatch => {
  try {
    await dispatch(updateBuyerInfo({ subscribedToBuyerDigest: status }))
    dispatch(
      flashNotification({
        message: status
          ? intl.formatMessage(SUBSCRIPTIONS.notificationSubscribed)
          : intl.formatMessage(SUBSCRIPTIONS.notificationUnsubscribed),
        messageType: 'error'
      })
    )
  } catch (e) {
    dispatch(
      flashNotification({
        message: intl.formatMessage(SUBSCRIPTIONS.notificationError),
        messageType: 'error'
      })
    )
  }
}

export const toggleSubscription = intl => (dispatch, getState) => {
  const state = getState()
  const isSubscribed = selectBuyerSubscribed(state)
  dispatch(setSubscriptionStatus(!isSubscribed, intl))
}

export const unsubscribeIfNeeded = intl => (dispatch, getState) => {
  const state = getState()

  const isSubscribed = selectBuyerSubscribed(state)
  const shouldUnsubscribe = selectBuyerUnsubscribeRequested(state)

  if (!shouldUnsubscribe) {
    return
  }

  dispatch(unmarkBuyerForUnsubscribe(intl))

  if (isSubscribed) {
    dispatch(toggleSubscription(intl))
  }
}
